/**
 * "Kasanız nerede dursun?" sorusunun durumu — kasanın kendi şifreli
 * ayarlarında (`DEPOLAMA_SORUSU_AYARI`); ekranı `DepolamaSorusu.tsx`.
 */

import { useCallback, useEffect, useState } from "react";
import { useRepositoryContext } from "../repo/RepositoryContext";
import { useYedek } from "../yedek/YedekSaglayici";

export const DEPOLAMA_SORUSU_AYARI = "depolama.soru";

/**
 * Sorunun durumu birden çok yerde okunur (ana sayfa, üç giriş sayfasının
 * uyarısı, Ayarlar › Depolama); biri cevaplayınca hepsi aynı anda kalkar.
 * Kasanın kendisi değişmediği için `invalidate()` (grafik önbelleğini de
 * siler) kullanılmaz; küçük bir dinleyici listesi yeter.
 */
const dinleyiciler = new Set<() => void>();

export interface DepolamaSorusuDurumu {
  /** Soru cevap bekliyor ve kasa henüz bir buluta bağlı değil. */
  readonly bekliyor: boolean;
  readonly yalnizcaCihaz: () => void;
}

export function useDepolamaSorusu(): DepolamaSorusuDurumu {
  const { repo, revision } = useRepositoryContext();
  const y = useYedek();
  const [ayar, setAyar] = useState<string | null>(null);
  const [tur, setTur] = useState(0);

  useEffect(() => {
    const d = (): void => setTur((t) => t + 1);
    dinleyiciler.add(d);
    return () => {
      dinleyiciler.delete(d);
    };
  }, []);

  useEffect(() => {
    let iptal = false;
    void repo.settings.get(DEPOLAMA_SORUSU_AYARI).then(
      (v) => {
        if (!iptal) setAyar(v);
      },
      () => undefined,
    );
    return () => {
      iptal = true;
    };
  }, [repo, revision, tur]);

  const cevapla = useCallback((): void => {
    void repo.settings.set(DEPOLAMA_SORUSU_AYARI, "cevaplandi").then(() => {
      for (const d of dinleyiciler) d();
    });
  }, [repo]);

  const kurulu = y?.durum.kurulu === true;
  useEffect(() => {
    // Bir buluta bağlanıldı: soru cevaplandı.
    if (ayar === "bekliyor" && kurulu) cevapla();
  }, [ayar, kurulu, cevapla]);

  return { bekliyor: ayar === "bekliyor" && y !== null && y.durum.kurulu === false, yalnizcaCihaz: cevapla };
}

